import type { PropType } from 'vue';
import { UPDATE_MODEL_VALUE } from '../../constants';

export interface CardProps {
    modelValue?: boolean,
    title?: string,
    loading?: boolean,
    noShadow?: boolean,
    showEditButton?: boolean,
    disableSaveButton?: boolean,
    disableEditButton?: boolean,
    transparentCard?: boolean,
}

export const cardProps = {
    modelValue: {
        type: Boolean as PropType<CardProps['modelValue']>,
        default: undefined,
        required: false,
    },
    title: {
        type: String as PropType<CardProps['title']>,
        default: undefined,
        required: false,
    },
    loading: {
        type: Boolean as PropType<CardProps['loading']>,
        default: undefined,
        required: false,
    },
    noShadow: {
        type: Boolean as PropType<CardProps['noShadow']>,
        default: undefined,
        required: false,
    },
    showEditButton: {
        type: Boolean as PropType<CardProps['showEditButton']>,
        default: false,
        required: false,
    },
    disableSaveButton: {
        type: Boolean as PropType<CardProps['disableSaveButton']>,
        default: undefined,
        required: false,
    },
    disableEditButton: {
        type: Boolean as PropType<CardProps['disableEditButton']>,
        default: undefined,
        required: false,
    },
    transparentCard: {
        type: Boolean as PropType<CardProps['transparentCard']>,
        default: undefined,
        required: false,
    },
}

export const cardEmits = {
    [UPDATE_MODEL_VALUE]: (event: boolean) => event,
    edit: (event: boolean) => event,
    reset: (event: boolean) => event,
    save: (event: boolean) => event,
};
